import {
  getAuthCookiePath,
  getAuthCookiePaths,
  getReturnToPath,
  isSessionExpired as checkSessionExpired
} from './auth-session'

export const useAuth = () => {
  const authenticated = useState('auth-authenticated', () => false)
  const user = useState('auth-user', () => null)
  const token = useState('auth-token', () => null)
  const baseURL = useRuntimeConfig().app.baseURL
  const authCookieOptions = { path: getAuthCookiePath(baseURL) }
  const tokenCookieOptions = {
    ...authCookieOptions,
    encode: val => String(val),
    decode: val => val
  }
  const sessionExpiredRedirect = useState('auth-session-expired', () => false)

  const readCookie = (name, options) => {
    const cookie = useCookie(name, options)
    if (cookie.value !== undefined && cookie.value !== null) return cookie

    if (options.path && options.path !== '/') {
      return useCookie(name, { ...options, path: '/' })
    }

    return cookie
  }

  const loginWithOtp = async (mobile, channel) => {
    // console.log('[loginWithOtp] Sending:', { mobile, channel })
    const result = await $fetch('/market/api/auth/send-otp', {
      method: 'POST',
      body: { mobile, channel }
    })
    return result
  }

  const setAuthSession = ({ token: t, user: u } = {}) => {
    authenticated.value = true
    user.value = u || null
    token.value = t || null

    const authCookie = useCookie('authenticated', authCookieOptions)
    authCookie.value = true
    const userCookie = useCookie('user', authCookieOptions)
    userCookie.value = u || null
    const tokenCookie = useCookie('auth_token', tokenCookieOptions)
    tokenCookie.value = t || null
    sessionExpiredRedirect.value = false
  }

  const verifyOtp = async (mobile, otp) => {
    // console.log('[verifyOtp] Sending:', { mobile, otp })
    const result = await $fetch('/market/api/auth/verify-otp', {
      method: 'POST',
      body: { mobile, otp }
    })

    if (result.ok) {
      setAuthSession({ token: result.token, user: result.user })
    }

    return result
  }

  const loginWithToken = async ({ token: t, user: u } = {}) => {
    if (!t) return { ok: false }
    setAuthSession({ token: t, user: u })
    return { ok: true, token: t, user: u }
  }

  const clearAuth = () => {
    authenticated.value = false
    user.value = null
    token.value = null

    const clearCookie = (name, options) => {
      for (const path of getAuthCookiePaths(baseURL)) {
        useCookie(name, { ...options, path }).value = null
      }
    }

    clearCookie('authenticated', authCookieOptions)
    clearCookie('user', authCookieOptions)
    clearCookie('auth_token', tokenCookieOptions)
  }

  const logout = async () => {
    clearAuth()
    sessionExpiredRedirect.value = false
  }

  const initAuth = () => {
    const authCookie = readCookie('authenticated', authCookieOptions)
    const userCookie = readCookie('user', authCookieOptions)
    const tokenCookie = readCookie('auth_token', tokenCookieOptions)

    if (authCookie.value) {
      authenticated.value = true
      user.value = userCookie.value || null
      token.value = tokenCookie.value || null
    }
  }

  const getAuthHeaders = () => {
    if (!token.value) return {}
    return {
      Authorization: `Token ${token.value}`
    }
  }

  const isSessionExpired = checkSessionExpired

  const handleSessionExpired = (error, message) => {
    if (!checkSessionExpired(error)) return false

    if (sessionExpiredRedirect.value) return true
    logout()

    if (process.client) {
      try {
        const toast = useToast()
        toast.add({ title: message || 'نشست شما منقضی شده است، لطفا دوباره وارد شوید', color: 'error', timeout: 5000 })
      } catch (e) { /* toast not available */ }

      const requestURL = useRequestURL()
      const returnTo = getReturnToPath(`${requestURL.pathname}${requestURL.search}`, baseURL)
      const redirect = encodeURIComponent(returnTo)
      sessionExpiredRedirect.value = true
      return navigateTo(`/login?redirect=${redirect}`) || true
    }

    return true
  }

  initAuth()

  return {
    authenticated: readonly(authenticated),
    user: readonly(user),
    token: readonly(token),
    loginWithOtp,
    verifyOtp,
    loginWithToken,
    logout,
    initAuth,
    getAuthHeaders,
    isSessionExpired,
    handleSessionExpired
  }
}